<script setup lang="ts">
    import { menuDefault } from '@/data/sidebar';
    import type { ButtonMenuProps } from '@/types/components/button';
    import type { SidebarProps } from '@/types/components/sidebar';
    import { PhCaretRight } from '@phosphor-icons/vue';
    import { computed } from 'vue';
    import { useRoute } from 'vue-router';

    const props = withDefaults(defineProps<SidebarProps>(), {
        isOpen: true
    });

    const route = useRoute();
    const menu = computed<ButtonMenuProps[]>(() => {
        return menuDefault;
    });

    // data of menu have child
    const subMenu = computed(() => {
        return menu.value.filter(
            (item): item is ButtonMenuProps & { children: { path: string; label: string }[] } =>
                Array.isArray(item.children) && item.children.length > 0
        );
    });

    // data of menu have no child
    const defaultMenu = computed(() => {
        return menu.value.filter(item => !item.children || item.children.length === 0);
    });

    const settings = computed(
        () => route.meta.group === 'setting' || route.meta.group === 'notification'
    );
    const active = (item: { group: string }) => item.group === route.meta.group;

    const emit = defineEmits(['toggle']);
</script>

<template>
    <div
        :class="{
            'max-w-[88px]': !isOpen,
            'w-[248px]': isOpen
        }"
        class="bg-white py-4 fixed top-0 left-0 z-1002 h-screen transition-all duration-200"
        style="
            box-shadow:
                0px 1px 3px 0px rgba(0, 0, 0, 0.1),
                0px 1px 2px 0px rgba(0, 0, 0, 0.06);
        "
    >
        <PhCaretRight
            @click="emit('toggle')"
            :class="{
                'rotate-0': !isOpen,
                'rotate-180': isOpen
            }"
            class="text-brand-500 bg-brand-50 p-1 rounded-full cursor-pointer absolute -right-4 top-7 w-7 h-7 flex-center hover:bg-brand-100 transition-all duration-200"
            size="8"
        />

        <SidebarOpen
            v-if="props.isOpen"
            :active="active"
            :defaultMenu="defaultMenu"
            :subMenu="subMenu"
            :settings="settings"
        />
        <SidebarClose
            v-else-if="!props.isOpen"
            :active="active"
            :defaultMenu="defaultMenu"
            :subMenu="subMenu"
            :settings="settings"
        />
    </div>
</template>
